import { Grid, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import ActionStatus from "../../../../../components/ActionStatus";

export default function SettingsSection({
  title,
  Icon,
  fetchStatus,
  setFetchStatus,
  children,
}) {
  const colors = useColors();

  return (
    <Grid container direction="column" gap={1}>
      {/* Title */}
      <Grid item>
        <Grid container direction="row" gap={1} justifyContent="space-between">
          <Grid item>
            <Grid container direction="row" gap={1} alignItems="center">
              <Grid item sx={{ display: "flex", alignItems: "center" }}>
                <Icon fontSize="small" />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" color={colors.text_primary}>
                  {title}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <ActionStatus status={fetchStatus} setStatus={setFetchStatus} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{children}</Grid>
    </Grid>
  );
}
